import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { parseISO } from 'date-fns/esm';
import {
  ZefScheduler,
  calculateDurationInSeconds,
  formatDurationFromMinutes
} from '@zerops/zef/core';

@Component({
  selector: 'zui-duration',
  templateUrl: './duration.component.html',
  styleUrls: [ './duration.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DurationComponent extends ZefScheduler implements OnDestroy, AfterViewInit {

  @Input()
  useShorthand = false;

  @Input()
  set start(v) {
    if (!!v) {
      this._startIso = parseISO(v);

      this.formatted = this._setFormattedDuration();
      this._start = v;

      this._startTimer();

      /**
       * To solve cases when the start input is initially not defined and the end input is defined.
       * When the start input is later updated it is necessary to refresh also the end input once.
       */
      if (this.end && !this._refreshEndDone) {
        this._refreshEnd(this.end);
        this._refreshEndDone = true;
      }
    }
  }
  get start() {
    return this._start;
  }

  @Input()
  set end(v) {
    this._end = v;
    this._refreshEnd(v);
  }
  get end() {
    return this._end;
  }

  formatted: string;
  private _interval: number;
  private _startIso: Date;
  private _start: string;
  private _end: string;
  private _refreshEndDone = false;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    this._startTimer();
  }

  ngOnDestroy() {
    this._stopTimer();
  }

  private _stopTimer() {
    clearInterval(this._interval);
  }

  private _startTimer() {
    if (this.start && !this.end && this._interval === undefined) {
      this._interval = setInterval(() => {
        this.formatted = this._setFormattedDuration();
        this.renderScheduler.schedule();
      }, 1000) as any;
    }
  }

  private _setFormattedDuration(end?: Date) {
    const durationSeconds = calculateDurationInSeconds(this._startIso, end);
    return formatDurationFromMinutes(durationSeconds / 60, this.useShorthand);
  }

  private _refreshEnd(v: string) {
    if (!!v && !!this.start) {
      this.formatted = this._setFormattedDuration(parseISO(v));
      this._stopTimer();
    }
  }

}
